import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { TrustpilotService } from 'src/app/services/trustpilot/trustpilot.service';

@Component({
  selector: 'app-trustbox-footer-widget',
  templateUrl: './trustbox-footer-widget.component.html'
})

export class TrustboxFooterWidgetComponent implements AfterViewInit {
  @ViewChild('trustbox') private trustbox?: ElementRef<HTMLElement>;

  constructor(private trustpilotService: TrustpilotService) {}

  ngAfterViewInit(): void {
    this.trustpilotService.render(this.trustbox?.nativeElement);
  }
}
